export function dataSet(obj, path, value) {
    if (typeof path !== 'string') return

    const [key, ...rest] = path.split('.')

    if (rest.length === 0) {
        obj[key] = value
        return
    }

    if (!(key in obj)) {
        const nextKey = rest[0]
        obj[key] = /^\d+$/.test(nextKey) ? [] : {}
    }

    dataSet(obj[key], rest.join('.'), value)
}
export function dataGet(obj, path, defaultValue = undefined) {
    if (typeof path !== 'string') return defaultValue;

    const keys = path.split('.');

    return keys.reduce((acc, key) => {
        if (acc && typeof acc === 'object' && key in acc) {
            return acc[key];
        }
        return defaultValue;
    }, obj);
}

export function deepMerge(target, source) {
    for (const key in source) {
        const sourceVal = source[key];
        const targetVal = target[key];

        if (
            isObject(sourceVal) &&
            !Array.isArray(sourceVal)
        ) {
            if (!isObject(targetVal)) {
                target[key] = {};
            }
            deepMerge(target[key], sourceVal);
        } else {
            target[key] = sourceVal;
        }
    }
}

function isObject(val) {
    return val !== null && typeof val === 'object';
}

export function getNested(obj, path) {
  return path.split('.').reduce((o, key) => o?.[key], obj);
}

/**
 * Convert Laravel-style placeholders (":name") to the curly-brace syntax
 * vue-i18n interpolates ("{name}"), scoped to validation messages.
 *
 * The shared translation bundles store validation messages in Laravel's format
 * (e.g. "validation.required" => ":attribute ist erforderlich."), but vue-i18n
 * only substitutes named arguments written as "{attribute}". Without this
 * conversion the placeholder is rendered verbatim, so the field label never
 * appears in the error message (AIRLST-5061). Scoping to "validation.*" keys
 * avoids touching colons that legitimately appear in other messages.
 *
 * @param {Record<string, unknown>} messages Flat translation map for one locale.
 * @returns {Record<string, unknown>} A new map with validation placeholders converted.
 */
export function convertValidationPlaceholders(messages) {
    const converted = {};

    for (const [key, value] of Object.entries(messages)) {
        converted[key] =
            key.startsWith('validation.') && typeof value === 'string'
                ? value.replace(/:([a-zA-Z_]+)/g, '{$1}')
                : value;
    }

    return converted;
}
